import React from "react";
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import '../RadarChart/RadarChart.css';

const data = [
  { subject: "Growth", value: 80, fullMark: 100 },
  { subject: "GF Value", value: 60, fullMark: 100 },
  { subject: "Momentum", value: 40, fullMark: 100 },
  { subject: "Financial Strength", value: 70, fullMark: 100 },
  { subject: "Stock", value: 20, fullMark: 90 },
];

const RadarChartData = () => {
  return (
    <div className="radar-container">
      <h2>Comprehensive Performance Metrics Radar: Growth, Momentum, and More</h2>
      <ResponsiveContainer height={400}>
        <RadarChart cx="50%" cy="50%" outerRadius="70%" data={data}>
          <PolarGrid gridType="circle" />
          <PolarAngleAxis
            dataKey="subject"
            style={{ fontSize: 14, fontWeight: "bold" }}
          />
          <PolarRadiusAxis angle={90} domain={[0, 100]} tick={false} axisLine={false} />
          <Radar
            name="Metrics"
            dataKey="value"
            stroke="#50C878"   // Border color
            fill="#50C878"
            fillOpacity={0.6}
            strokeWidth={3}    // Border thickness
            dot={{ r: 5, stroke: '#50C878', strokeWidth: 2, fill: '#fff' }}  // Dot configuration
          />
          <Tooltip />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RadarChartData;
